import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCollapse = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 10.4989C12.1092 10.4989 12.2129 10.4756 12.3065 10.4338L12.4968 10.3112C12.5085 10.3009 12.5199 10.2901 12.5311 10.2789L16.78 6.03001C17.0734 5.73669 17.0734 5.26111 16.78 4.96779C16.4867 4.67446 16.0111 4.67446 15.7178 4.96778L12.7511 7.93445V2.00111C12.7511 1.58628 12.4149 1.25 12 1.25C11.5852 1.25 11.2489 1.58628 11.2489 2.00111V7.93447L8.28224 4.96779C7.98892 4.67446 7.51334 4.67446 7.22002 4.96779C6.92669 5.26111 6.92669 5.73669 7.22002 6.03001L11.4689 10.2789L11.4705 10.2805C11.5401 10.3497 11.6198 10.4024 11.7049 10.4387C11.7955 10.4775 11.8953 10.4989 12 10.4989Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.766 12.0099C4.76807 12.4191 5.10061 12.7497 5.50986 12.7493L18.4561 12.737C18.8646 12.7366 19.1963 12.4065 19.1985 11.998C19.2008 11.5857 18.867 11.2503 18.4547 11.2507L5.50845 11.263C5.09682 11.2634 4.76392 11.5983 4.766 12.0099Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3065 13.5662C12.2129 13.5244 12.1092 13.5011 12 13.5011C11.8953 13.5011 11.7955 13.5225 11.7049 13.5613C11.6198 13.5976 11.5401 13.6503 11.4705 13.7195L11.4689 13.7211L7.22002 17.97C6.92669 18.2633 6.92669 18.7389 7.22002 19.0322C7.51334 19.3255 7.98892 19.3255 8.28224 19.0322L11.2489 16.0655V21.9989C11.2489 22.4137 11.5852 22.75 12 22.75C12.4149 22.75 12.7511 22.4137 12.7511 21.9989V16.0655L15.7178 19.0322C16.0111 19.3255 16.4867 19.3255 16.78 19.0322C17.0734 18.7389 17.0734 18.2633 16.78 17.97L12.5311 13.7211C12.5199 13.7099 12.5085 13.6991 12.4968 13.6888L12.3065 13.5662Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconCollapse as ReactComponent };
